import React from 'react';
import { Row, Button, Col, Spinner } from 'react-bootstrap';
import KeyboardBackspaceRoundedIcon from '@material-ui/icons/KeyboardBackspaceRounded';
import 'date-fns';
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';

import { dateFormatUtil ,getFormattedDateTime,getFormattedDate} from '../Utilities';
import Form from 'react-bootstrap/Form';
import MaterialTable from 'material-table';
import { PatchedPagination } from '../services/PatchedPagination.js';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { withAuthorization } from '../Session';
import Alert from 'react-bootstrap/Alert';
import RestServices from '../services/RestServices.js';
import queryString from 'query-string';

function getColumns() {
    let columns = [
        { title: 'Sale Name', field: 'saletitle' },
        { title: 'From Date', field: 'salefrom',render: (item) => getFormattedDate(item.salefrom) },
        { title: 'To Date', field: 'saleto' ,render: (item) => getFormattedDate(item.saleto)},
        { title: 'Status', field: 'status', render: (item) => getStatus(item) },
        { title: 'Created', field: 'DateTime' ,render: (item) => getFormattedDateTime(item.DateTime)}
    ];
    return columns;
}

function getStatus(item) {
    let date = new Date();
    var dd = String(date.getDate()).padStart(2, '0');
    var mm = String(date.getMonth() + 1).padStart(2, '0');
    var yyyy = date.getFullYear();

    let todayDate = yyyy + '-' + mm + '-' + dd;

    var saleto = new Date(item.saleto);
    if (item.status === '1') {
        if (saleto.getTime() > date.getTime()) {
            return 'Active';
        } else {
            return 'Expired';
        }
    } else {
        return 'Disabled';
    }
}

function todayDate() {
    let date = new Date();
    var dd = String(date.getDate()).padStart(2, '0');
    var mm = String(date.getMonth() + 1).padStart(2, '0');
    var yyyy = date.getFullYear();

    date = yyyy + '-' + mm + '-' + dd;
    return date;
}

class AllSales extends React.Component {
    _isMounted = false;

    state = {
        alert: 0,
        alertMessage: '',
        saledocId: '',
        saletitle: '',
        salefrom: '',
        status: '',
        saleto: '',
        flag: 0,
        data: [],
        showAddEdit: false,
        selectedRow: [],
        saleStatus: 'Active',
        saleOptions: ['Active', 'Disabled']
    };

    async componentDidMount() {
        this._isMounted = true;
        this.loadData();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    async loadData() {
        this.setState({ flag: 1 });
        await RestServices.getAllSales(
            localStorage.getItem('FirebaseToken')
        )
            .then((response) => response.json())
            .then(async (responseData) => {
                //console.log(responseData);
                if (this._isMounted) {
                    this.setState({
                        showAddEdit: false,
                        data: responseData,
                        flag: 2
                    });
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({
                        data: [],
                        flag: 1,
                        alert: 1,
                        alertMessage: err.message
                    });
                }
            });
    }

    CancelAddEdit() {
        if (this._isMounted) {
            this.setState({ showAddEdit: false });
        }
    }

    async submitAddEdit() {
        let bodyData = {
            saledocId: this.state.saledocId,
            saletitle: this.state.saletitle,
            salefrom: this.state.salefrom,
            saleto: this.state.saleto,
            status: '' + this.state.status,
            LastUpdatedTimeStamp: dateFormatUtil(),
            UpdatedBy: this.props.user.FullName
                ? this.props.user.FullName
                : 'Admin'
        };
        //console.log(bodyData);

        await RestServices.addEditSale(
            localStorage.getItem('FirebaseToken'),
            bodyData
        )
            .then((response) => response.json())
            .then((responseData) => {
                //console.log(responseData);
                this.loadData();
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({
                        flag: 4,
                        alert: 1,
                        alertMessage: err.message
                    });
                }
            });
    }

    onChangeValues = (event) => {
        if (event.target.value === '')
            this.setState({ [event.target.name]: '' });
        else {
            this.setState({ [event.target.name]: event.target.value });
        }
    };

    render() {
        const actions = [
            {
                icon: 'add',
                tooltip: 'Add new',
                position: 'toolbar',
                onClick: () => {
                    if (this._isMounted) {
                        this.setState({
                            showAddEdit: true,
                            saledocId: null,
                            saletitle: null,
                            salefrom: null,
                            saleto: null,
                            status: null,
                            saleStatus: null
                        });
                    }
                }
            },
            {
                icon: 'edit',
                tooltip: 'Edit Sale',
                onClick: (event, rowData) => {
                    //console.log(rowData);

                    if (rowData.status === '1') {
                        var saleStatus = 'Active';
                    } else {
                        var saleStatus = 'Disabled';
                    }

                    if (this._isMounted) {
                        this.setState({
                            showAddEdit: true,
                            saledocId: rowData.docId,
                            saletitle: rowData.saletitle,
                            salefrom: rowData.salefrom,
                            saleto: rowData.saleto,
                            status: rowData.status,
                            saleStatus: saleStatus
                        });
                    }
                }
            }
        ];

        return (
            <div>
                {this.state.flag === 1 && <Spinner animation="border" />}

                {this.state.alert === 1 && (
                    <Row>
                        <Col>
                            <Alert variant="danger">
                                {this.state.alertMessage}
                            </Alert>
                        </Col>
                    </Row>
                )}

                {this.state.alert === 2 && (
                    <Row>
                        <Col>
                            <Alert variant="success">
                                {this.state.alertMessage}
                            </Alert>
                        </Col>
                    </Row>
                )}

                {this.state.showAddEdit && (
                    <div>
                        <Form.Group>
                            <Form.Label>Sales Title</Form.Label>
                            <Form.Control
                                value={this.state.saletitle}
                                onChange={(e) =>
                                    this.setState({ saletitle: e.target.value })
                                }
                                name="saletitle"
                                type="text"
                                placeholder="Enter Title"
                            />
                        </Form.Group>

                        <Form.Group>
                            <Form.Label>Sales From</Form.Label>
                            <Form.Control
                                placeholder="Enter Start Date"
                                type="date"
                                name="salefrom"
                                value={this.state.salefrom}
                                onChange={this.onChangeValues}
                            />
                        </Form.Group>

                        <Form.Group>
                            <Form.Label>Sales To</Form.Label>
                            <Form.Control
                                placeholder="Enter End Date"
                                type="date"
                                name="saleto"
                                value={this.state.saleto}
                                onChange={this.onChangeValues}
                            />
                        </Form.Group>

                        <Form.Group>
                            <Form.Label>
                                Sales Status {this.state.saleStatus}
                            </Form.Label>
                            <Autocomplete
                                name="saleStatus"
                                value={this.state.saleStatus}
                                onChange={(event, newValue) => {
                                    if (newValue === 'Active') {
                                        this.setState({ status: 1 });
                                    } else {
                                        this.setState({ status: 0 });
                                    }
                                    this.setState({ saleStatus: newValue });
                                }}
                                id="sale_status"
                                options={this.state.saleOptions.map(
                                    (arr) => arr
                                )}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        margin="dense"
                                        variant="outlined"
                                    />
                                )}
                            />
                        </Form.Group>

                        <Form.Group>
                            <Button
                                onClick={() => {
                                    this.CancelAddEdit();
                                }}
                                style={{
                                    marginLeft: '1rem',
                                    marginTop: '0.3rem'
                                }}
                            >
                                Cancel
                            </Button>
                            <Button
                                onClick={() => {
                                    this.submitAddEdit();
                                }}
                                style={{
                                    marginLeft: '0.5rem',
                                    marginTop: '0.3rem'
                                }}
                            >
                                Submit
                            </Button>
                        </Form.Group>
                    </div>
                )}

                {!this.state.showAddEdit && (
                    <MaterialTable
                        components={{ Pagination: PatchedPagination }}
                        title="Sales"
                        columns={getColumns()}
                        data={this.state.data}
                        actions={actions}
                        options={{
                            filtering: false,
                            actionsColumnIndex: -1,
                            search: true,
                            pageSize: 15,
                            pageSizeOptions: [15, 25, 50, 100]
                        }}
                    />
                )}
            </div>
        );
    }
}

const condition = (authUser) => !!authUser;
export default withAuthorization(condition)(AllSales);
